<div style="margin: 4px">
    <span class="glyphicon glyphicon-user"></span>
 	<input class="ui-autocomplete-input" style="border: none; border-radius: 4px; color: #000000" type="text" [(ngModel)]="typeaheadValue"
		[typeahead]="entities"
		(typeaheadLoading)="changeTypeaheadLoading($event)"
		(typeaheadOnSelect)="typeaheadOnSelect($event)"
		typeaheadOptionField="name" />
    <span (click)="removeClicked.emit()" class="fa fa-close"></span>
</div>